import { render, staticRenderFns } from "./EditUserMsg.vue?vue&type=template&id=0c45bd40&"
import script from "./EditUserMsg.vue?vue&type=script&lang=js&"
export * from "./EditUserMsg.vue?vue&type=script&lang=js&"
import style0 from "./EditUserMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports